import { CreateColumnsParams } from './types';

// Returns 6 empty objects — one per data column (Title, Date, Source, Size, Price Per Share, Weighting).
// The actual cell values are generated in the parser from tableData.sourceRows.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createColumns = (_params: CreateColumnsParams): object[] => [{}, {}, {}, {}, {}, {}];

export default createColumns;
